import { render, staticRenderFns } from "./Recordingand.vue?vue&type=template&id=5384f81b&scoped=true"
import script from "./Recordingand.vue?vue&type=script&lang=js"
export * from "./Recordingand.vue?vue&type=script&lang=js"
import style0 from "./Recordingand.vue?vue&type=style&index=0&id=5384f81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384f81b",
  null
  
)

export default component.exports